import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "./ui/table";
import { Building2 } from "lucide-react";

const gradeChip = (grade) => {
  const isInvestment = grade.startsWith("AAA") || grade.startsWith("AA");
  return (
    <span
      className="inline-flex items-center rounded-sm px-2 py-0.5 text-[11px] font-semibold uppercase tracking-widest"
      style={{
        background: isInvestment ? "rgba(212,175,55,0.14)" : "#F1F5F9",
        color: isInvestment ? "#8B6F1D" : "#334155",
        border: isInvestment ? "1px solid rgba(212,175,55,0.4)" : "1px solid #E2E8F0",
      }}
    >
      {grade}
    </span>
  );
};

export const TenantsTable = ({ tenants }) => {
  return (
    <section className="overflow-hidden rounded-lg border border-slate-200 bg-white" data-testid="tenants-table">
      <div className="flex items-end justify-between border-b border-slate-100 px-6 py-5">
        <div>
          <div className="overline">Covenants</div>
          <h2 className="mt-1 flex items-center gap-2 font-display text-2xl font-semibold tracking-tight text-slate-900">
            <Building2 className="h-5 w-5 brickstok-gold" /> Tenant Covenants
          </h2>
        </div>
        <div className="text-xs text-slate-500 font-mono-num">{tenants.length} anchor tenants</div>
      </div>
      <Table>
        <TableHeader>
          <TableRow className="bg-slate-50 hover:bg-slate-50">
            <TableHead className="pl-6 uppercase tracking-widest text-[11px] text-slate-500">Tenant</TableHead>
            <TableHead className="uppercase tracking-widest text-[11px] text-slate-500">Credit Grade</TableHead>
            <TableHead className="text-center uppercase tracking-widest text-[11px] text-slate-500">Lease Expiry</TableHead>
            <TableHead className="pr-6 text-right uppercase tracking-widest text-[11px] text-slate-500">Share of Rent</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {tenants.map((t, idx) => (
            <TableRow key={t.name} data-testid={`tenant-row-${idx}`} className="hover:bg-slate-50/60">
              <TableCell className="pl-6 font-medium text-slate-900">{t.name}</TableCell>
              <TableCell>{gradeChip(t.grade)}</TableCell>
              <TableCell className="text-center font-mono-num text-slate-700">{t.expiry}</TableCell>
              <TableCell className="pr-6 text-right">
                <div className="ml-auto flex w-40 items-center justify-end gap-3">
                  <div className="relative h-1.5 w-full max-w-24 overflow-hidden rounded-full bg-slate-100">
                    <div
                      className="h-full rounded-full transition-[width] duration-700"
                      style={{
                        width: `${t.share_pct}%`,
                        background: "linear-gradient(90deg,#D4AF37,#B8941F)",
                      }}
                    />
                  </div>
                  <span className="font-mono-num text-sm font-semibold text-slate-900">{t.share_pct}%</span>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </section>
  );
};

export default TenantsTable;
